export var FeatureFlags;
(function (FeatureFlags) {
    FeatureFlags.BusinessUnitFeatureFlag = "6508310d-8dfd-4812-b476-74398ca18ee7";
})(FeatureFlags || (FeatureFlags = {}));
